/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BADGE_STATE_SUCCESS, BADGE_TYPE_OUTLINE, BADGE_TYPE_STRONG, Badge } from '@squiz/sds';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_STRINGS } from '../../../../Constants/Strings.constants';
import { DamStatusBadgeProps } from './DamStatusBadge.props';

/**
 * The DAM status badge.
 */
export const DamStatusBadge = (props: DamStatusBadgeProps): JSX.Element => {
  const { t } = useTranslation();
  const { enabled } = props;

  // Labels
  const labels = useMemo(() => {
    return {
      disabled: t(CONFIGURATION_STRINGS.disabled),
      enabled: t(CONFIGURATION_STRINGS.enabled),
    };
  }, [t]);

  const badgeText = enabled ? labels.enabled : labels.disabled;
  const badgeState = enabled ? BADGE_STATE_SUCCESS : undefined;
  const badgeType = enabled ? BADGE_TYPE_STRONG : BADGE_TYPE_OUTLINE;

  return <Badge classes="dam-integration-item__status" left={badgeText} state={badgeState} type={badgeType} />;
};
